// Browser-side global error capture. Reports uncaught errors and unhandled
// promise rejections to Lovable's built-in capture (window.__lovableEvents).
// Source maps in the production build make these stacks readable.
import { reportLovableError } from "./lovable-error-reporting";

let installed = false;

export function installClientErrorCapture() {
  if (installed) return;
  if (typeof window === "undefined") return;
  installed = true;

  window.addEventListener("error", (event) => {
    const err = event.error ?? new Error(event.message || "Unknown error");
    reportLovableError(err, {
      source: "window.onerror",
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    const err = reason instanceof Error ? reason : new Error(String(reason));
    reportLovableError(err, { source: "unhandledrejection" });
  });
}
